<template>
  <div class="view-page-container">
    <div>
      <div class="unified-detail-card">
        <!-- ── HEADER ── -->
        <div class="udc-header pb-4">
          <div class="udc-profile-top">
            <div class="udc-profile-left">
              <div class="udc-avatar-wrap" style="border-radius: 16px">
                <div
                  class="udc-placeholder"
                  style="
                    background: var(--sb-act-bg) !important;
                    color: var(--brand);
                  "
                >
                  <v-icon size="32" color="var(--brand)"
                    >mdi-receipt-text-outline</v-icon
                  >
                </div>
              </div>
              <div class="udc-info">
                <h2 class="udc-name">{{ bill.title || "Loading..." }}</h2>
                <div class="udc-meta-row mt-2" v-if="bill.id">
                  <div class="udc-meta-item">
                    <v-icon size="14" color="#64748B"
                      >mdi-calendar-sync-outline</v-icon
                    >
                    <span class="udc-meta-text">{{ getType(bill.type) }}</span>
                  </div>
                  <span class="udc-meta-sep">|</span>
                  <div class="udc-meta-item">
                    <v-icon size="14" color="#64748B"
                      >mdi-clock-alert-outline</v-icon
                    >
                    <span class="udc-meta-text"
                      >Due in {{ bill.due_days }} days</span
                    >
                  </div>
                  <span
                    class="udc-meta-sep"
                    v-if="bill.members && bill.members.length"
                    >|</span
                  >
                  <div
                    class="udc-meta-item"
                    v-if="bill.members && bill.members.length"
                  >
                    <v-icon size="14" color="#64748B">mdi-home-group</v-icon>
                    <span class="udc-meta-text"
                      >{{ bill.members.length }} unit(s) selected</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="udc-profile-right">
              <button
                class="udc-edit-btn"
                v-if="!isOneTimeOverdue"
                @click="$router.push('/societyadmin/bills/edit/' + bill.id)"
              >
                <v-icon size="14" color="white">mdi-pencil-outline</v-icon>
                Edit
              </button>
              <button
                class="udc-back-btn"
                @click="$router.go(-1)"
                :style="{ color: buttonColor, borderColor: buttonColor }"
              >
                <v-icon size="16" class="arrow" :style="{ color: buttonColor }"
                  >mdi-arrow-left</v-icon
                >
                BACK
              </button>
            </div>
          </div>
        </div>

        <!-- ── CONTENT ── -->
        <div class="udc-content-wrap" v-if="bill.id">
          <!-- Template Profile -->
          <div class="premium-field-label mb-4">Template profile</div>
          <div class="info-grid mb-8">
            <div class="info-cell">
              <div class="cell-label">Title</div>
              <div class="cell-value">{{ bill.title }}</div>
            </div>
            <div class="info-cell">
              <div class="cell-label">Schedule type</div>
              <div class="cell-value">
                <span class="type-pill" :class="getTypeClass(bill.type)">{{
                  getType(bill.type)
                }}</span>
              </div>
            </div>

            <div class="info-cell" v-if="bill.type == 1">
              <div class="cell-label">Billing date</div>
              <div class="cell-value">
                {{ bill.one_time_date | formatDate }}
              </div>
            </div>
            <div class="info-cell" v-if="bill.type == 2 || bill.type == 3">
              <div class="cell-label">Day of month</div>
              <div class="cell-value">
                {{ bill.day_of_month || "N/A"
                }}<span v-if="bill.day_of_month">th</span>
              </div>
            </div>
            <div class="info-cell" v-if="bill.type == 3">
              <div class="cell-label">Billing month</div>
              <div class="cell-value">{{ bill.month || "N/A" }}</div>
            </div>

            <div class="info-cell">
              <div class="cell-label">Due days</div>
              <div class="cell-value">{{ bill.due_days }} days</div>
            </div>
            <div class="info-cell">
              <div class="cell-label">Next due date (est.)</div>
              <div class="cell-value due-date">
                {{ calculateDueDate() | formatDate }}
              </div>
            </div>
            <div class="info-cell">
              <div class="cell-label">Send to</div>
              <div class="cell-value">{{ getSendToText(bill.send_to) }}</div>
            </div>

            <div class="info-cell full">
              <div class="cell-label">Description</div>
              <div class="cell-value desc">
                {{ bill.description || "No description provided." }}
              </div>
            </div>
          </div>

          <!-- Pricing Structure -->
          <div class="premium-field-label mb-4">Pricing structure</div>
          <div class="pricing-row mb-8">
            <div class="price-card owner">
              <div class="price-card-label">Owners</div>
              <div class="price-card-amt">
                ₹{{ bill.amount }}
                <span v-if="bill.type != 1"
                  >/ {{ bill.type == 3 ? "year" : "month" }}</span
                >
              </div>
            </div>
            <div class="price-card tenant">
              <div class="price-card-label">Tenants</div>
              <div class="price-card-amt">
                ₹{{ bill.amount_for_rental }}
                <span v-if="bill.type != 1"
                  >/ {{ bill.type == 3 ? "year" : "month" }}</span
                >
              </div>
            </div>
          </div>

          <!-- Reference Documents -->
          <div class="notice-attachments-section mb-8">
            <div class="premium-field-label mb-4">Reference documents</div>
            <div class="doc-grid" v-if="bill.documents && bill.documents.length > 0">
              <div
                v-for="item in bill.documents"
                :key="item.id"
                class="doc-card"
                @click="openDocument(item)"
              >
                <v-img
                  v-if="item.file_type === 'image'"
                  :src="base_url + '/uploads/bill_documents/' + item.document_url"
                  class="doc-card-img"
                  contain
                />
                <div v-else class="doc-card-placeholder">
                  <v-icon color="#EF4444" size="52">mdi-file-pdf-box</v-icon>
                  <span class="doc-card-placeholder-label">PDF</span>
                </div>
                <div class="doc-card-overlay">
                  <div class="doc-overlay-btn">
                    <v-icon size="16" color="white">mdi-eye-outline</v-icon>
                    <span>View</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-state">
              <div class="empty-icon">
                <v-icon size="20" color="#9CA3AF">mdi-file-hidden</v-icon>
              </div>
              <span class="empty-text">No documents attached</span>
            </div>
          </div>

          <!-- Target Members -->
          <div class="notice-attachments-section">
            <div class="members-header mb-4">
              <div class="premium-field-label" style="margin-bottom: 0">
                Target members
              </div>
              <span class="count-pill"
                >{{ bill.members ? bill.members.length : 0 }} units
                selected</span
              >
            </div>
            <div
              class="member-grid"
              v-if="bill.members && bill.members.length > 0"
            >
              <div v-for="m in bill.members" :key="m.id" class="member-card">
                <div
                  class="unit-circle"
                  :style="{
                    color: primaryColor,
                    'background-color': primaryColor + '20',
                  }"
                >
                  {{ getUnitInitial(m) }}
                </div>
                <div class="unit-num">
                  <span v-if="m.flat_name">{{ m.flat_name }}-</span
                  >{{ m.house_number }}
                </div>
                <div class="unit-name">{{ m.name }}</div>
              </div>
            </div>
            <div v-else class="empty-state">
              <div class="empty-icon">
                <v-icon size="20" color="#9CA3AF"
                  >mdi-account-multiple-remove-outline</v-icon
                >
              </div>
              <span class="empty-text"
                >No specific members targeted for this bill master.</span
              >
            </div>
          </div>
        </div>

        <!-- Loading state -->
        <div v-else class="udc-content-wrap loading-state">
          <v-progress-circular indeterminate color="var(--brand)" size="32" />
        </div>
      </div>
    </div>

    <!-- ── Media Viewer ── -->
    <MediaViewer
      v-model="imageDialog"
      :items="mediaItems"
      :index="mediaIndex"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";
import MediaViewer from "../../common/MediaViewer.vue";

export default {
  name: "ViewBill",
  components: { MediaViewer },
  data() {
    return {
      user: {},
      loading: false,
      bill: {
        title: "",
        description: "",
        type: "",
        amount: "",
        amount_for_rental: "",
        day_of_month: "",
        month: "",
        one_time_date: "",
        documents: [],
        due_days: "",
        send_to: "",
        members: [],
      },
      base_url: process.env.VUE_APP_API_URL,
      imageDialog: false,
      mediaIndex: 0,
      types: [
        { text: "One Time", value: 1 },
        { text: "Monthly", value: 2 },
        { text: "Yearly", value: 3 },
      ],
    };
  },
  computed: {
    ...mapState("theme", ["primaryColor", "isDark", "buttonColor"]),
    mediaItems() {
      return (this.bill.documents || []).map(doc => ({
        url: this.base_url + '/uploads/bill_documents/' + doc.document_url,
        type: doc.file_type === 'image' ? 'image' : 'document',
        name: doc.document_url ? doc.document_url.split('/').pop() : 'file',
      }));
    },
    isOneTimeOverdue() {
      if (this.bill.type != 1) return false;
      const due = this.calculateDueDate();
      return due ? moment().isAfter(due, 'day') : false;
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),

    getBillDetail() {
      this.loading = true;
      this.$axios
        .get("societyadmin/bills/" + this.$route.params.id)
        .then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.bill = response.data.bill;
          } else {
            this.showErr(response.data.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getFormattedDate(date) {
      return date ? moment(date).format("DD MMM, YYYY") : "N/A";
    },

    calculateDueDate() {
      const { one_time_date, due_days } = this.bill;
      if (one_time_date && due_days)
        return moment(one_time_date).add(due_days, "days");
      return null;
    },

    getType(type) {
      const item = this.types.find((t) => t.value == type);
      return item ? item.text : "N/A";
    },

    getTypeClass(type) {
      if (type == 1) return "type-onetime";
      if (type == 2) return "type-monthly";
      return "type-yearly";
    },

    getSendToText(sendTo) {
      if (sendTo == 1) return "Owners only";
      if (sendTo == 2) return "Tenants only";
      if (sendTo == 3) return "All members";
      return "Unknown";
    },

    getUnitInitial(m) {
      return m.name
        ? m.name.charAt(0).toUpperCase()
        : m.house_number
        ? m.house_number.charAt(0)
        : "-";
    },

    openDocument(item) {
      this.mediaIndex = (this.bill.documents || []).indexOf(item);
      this.imageDialog = true;
    },

    showErr(msg) {
      this.setAlert({
        showAlert: true,
        message: msg,
        variant: "red accent-3",
        timeout: 2000,
      });
    },
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getBillDetail();
  },
};
</script>

<style scoped>
.view-page-container {
  padding: 24px;
}

/* ── Unified Card ── */
.unified-detail-card {
  background: var(--surface);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
}

/* ── Header ── */
.udc-header {
  padding: 16px 16px 0px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}
.udc-profile-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  position: relative;
  padding-bottom: 16px;
}
.udc-profile-left {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding-right: 100px;
}
.udc-avatar-wrap {
  width: 64px;
  height: 64px;
  overflow: hidden;
  flex-shrink: 0;
  background: var(--surface2);
}
.udc-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.udc-info {
  flex: 1;
}
.udc-name {
  font-size: 20px;
  font-weight: 700;
  color: var(--tx);
  margin: 0 0 6px 0;
  letter-spacing: -0.01em;
  line-height: 1.2;
}
.udc-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}
.udc-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.udc-meta-text {
  font-size: 13px;
  color: var(--tx2);
  font-weight: 500;
}
.udc-meta-sep {
  color: var(--border);
  font-size: 14px;
  opacity: 0.6;
}

/* ── Header Buttons ── */
.udc-profile-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.udc-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  height: 38px;
  border: none;
  border-radius: 8px;
  background: var(--btn-color, #0d9972);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: opacity 0.2s;
}
.udc-edit-btn:hover {
  opacity: 0.88;
}

.udc-profile-right {
  position: absolute;
  top: 0;
  right: 0;
  flex-shrink: 0;
}

/* Back Button */
.udc-back-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 0 14px 0 10px !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  letter-spacing: 0.05em !important;
  border-radius: 8px !important;
  color: var(--btn-color) !important;
  border: 1px solid var(--btn-color) !important;
  background: var(--surface2) !important;
  height: 38px !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}

.udc-back-btn:hover {
  background: var(--surface2) !important;
  border-color: var(--btn-color) !important;
}

.arrow {
  color: var(--btn-color) !important;
}

/* ── Content Wrap ── */
.udc-content-wrap {
  background: var(--surface2);
  padding: 16px;
  min-height: 200px;
}
.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

/* ── Section Label ── */
.premium-field-label {
  font-size: 11px;
  font-weight: 700;
  color: var(--tx3, #64748b);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* ── Info Grid — box-shadow trick for clean borders ── */
.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: var(--border);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}
.info-cell {
  padding: 14px 16px;
  background: var(--surface);
}
.info-cell.full {
  grid-column: span 2;
}

.cell-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--tx3, #6b7280);
  margin-bottom: 5px;
}
.cell-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--tx, #111827);
  line-height: 1.4;
}
.cell-value.desc {
  font-size: 13.5px;
  line-height: 1.65;
  white-space: pre-line;
  font-weight: 500;
  color: var(--tx2, #374151);
}
.cell-value.due-date {
  color: #d85a30;
}

/* ── Type Pills ── */
.type-pill {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
}
.type-monthly {
  background: #e1f5ee;
  color: #0f6e56;
  border: 1px solid #5dcaa5;
}
.type-onetime {
  background: #eeedfe;
  color: #534ab7;
  border: 1px solid #afa9ec;
}
.type-yearly {
  background: #faeeda;
  color: #854f0b;
  border: 1px solid #ef9f27;
}

/* ── Pricing ── */
.pricing-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.price-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 18px 20px;
}
.price-card-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--tx3);
  margin-bottom: 8px;
}
.price-card-amt {
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}
.price-card-amt span {
  font-size: 13px;
  color: var(--tx3);
  font-weight: 500;
}
.price-card.owner .price-card-amt {
  color: #0f6e56;
}
.price-card.tenant .price-card-amt {
  color: #534ab7;
}

/* ── Attachments (identical to notice) ── */
.attachment-card-premium {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  height: 200px;
  aspect-ratio: 1;
  background: var(--surface);
  border: 1px solid var(--border);
  transition: all 0.25s ease;
  cursor: pointer;
}
.attachment-card-premium:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}
.attachment-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.attachment-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
}
.attachment-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.38);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}
.attachment-card-premium:hover .attachment-overlay {
  opacity: 1;
}
.overlay-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 13px;
  font-weight: 700;
}

/* ── Members ── */
.members-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.count-pill {
  padding: 4px 12px;
  border-radius: 20px;
  background: #e1f5ee;
  color: #0f6e56;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #5dcaa5;
}
.member-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}
.member-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 12px;
  text-align: center;
}
.unit-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 10px;
  font-size: 16px;
  font-weight: 700;
}
.unit-num {
  font-size: 13px;
  font-weight: 700;
  color: var(--tx);
  margin-bottom: 3px;
}
.unit-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--tx3);
}

/* ── Empty State ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 24px;
  gap: 10px;
  width: 25%;
  background: var(--surface);
  border-radius: 12px;
  border: 1px solid var(--border);
}
.empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--surface2);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-text {
  font-size: 13px;
  font-weight: 500;
  color: var(--tx3);
  text-align: center;
}

/* ── Lightbox ── */
.lightbox-wrap {
  background: var(--surface);
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.lightbox-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--surface2);
  flex-shrink: 0;
}

.lightbox-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  color: var(--tx);
}

.lightbox-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lb-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}
.lb-btn:hover {
  background: var(--surface3);
  border-color: var(--brand);
}
.lb-close:hover {
  background: rgba(239, 68, 68, 0.08);
  border-color: #ef4444;
}
.lb-close:hover .v-icon {
  color: #ef4444 !important;
}

.lightbox-body {
  flex: 1;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0a0a0a;
  min-height: 300px;
  max-height: calc(90vh - 60px);
}

.lightbox-img {
  max-width: 100%;
  max-height: calc(90vh - 60px);
  object-fit: contain;
  display: block;
}

.pdf-body {
  background: var(--surface2);
}

.lightbox-pdf {
  width: 100%;
  height: calc(90vh - 60px);
  min-height: 500px;
  border: none;
  display: block;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .udc-profile-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .udc-profile-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .udc-meta-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .udc-meta-sep {
    display: none;
  }
  .udc-profile-right {
    width: 100%;
    justify-content: flex-start;
  }
  .udc-content-wrap {
    padding: 16px;
  }
  .pricing-row {
    grid-template-columns: 1fr;
  }
  .info-grid {
    grid-template-columns: 1fr;
  }
  .info-cell {
    box-shadow: 0 1px 0 0 var(--border) !important;
  }
  .info-cell:last-child {
    box-shadow: none !important;
  }
}
</style>
